export default [
  {
    title: 'Ongi etorri',
    element: '.none',
    text: 'Ongi etorri {{wlName}}-ra, zure irudiak trukatzeko plataformara. Tour honetan erabiltzen ikasten lagunduko dizugu.'
  },
  {
    title: 'Emaitza medikoak',
    element: '.icons-layout',
    text: 'Hemen ikusi ahal izango dituzu partekatu dizkizuten karpeta, dokumentu eta proba mediko guztiak.'
  },
  {
    title: 'Oraindik ez dago emaitzarik',
    element: '.empty-folder',
    text: 'Badirudi zure emaitzak oraindik ez direla igo. Prozesu honek egun batzuk iraun ditzake.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  },
  {
    title: 'Fitxategiak ikusi',
    element: '.icon-wrapper-file',
    text: '<strong>Klik </strong> egin dezakezu karpetetan sartzeko edo fitxategiak irekitzeko.',
    placement: {
      relativeTo: 'element',
      position: 'right top'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/mobile/eu-ES/guestTour.js